module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../axios/index.js
// module id = 1506
// module chunks = 25